import { Component, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ensena',
  templateUrl: './ensena.component.html',
  styleUrls: ['./ensena.component.css']
})
export class EnsenaComponent implements OnInit {

  ensenaPredyc: string = "assets/images/design/ensena-predyc.jpg"
  registerForm: FormGroup;
  habilitarEnviar: number = 0;
  enviado = false;



  constructor(private formBuilder: FormBuilder, private functions: AngularFireFunctions) { }

  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      nombres: ['', Validators.required],
      infoProfesional: ['', Validators.required],
      email: ['', Validators.required],
      empresa: [''],
      telefono: ['', Validators.required],
      pais: ['', Validators.required],
      titulo: ['', Validators.required],
      descripcionCurso: ['', Validators.required],
    });
    this.registerForm.valueChanges.subscribe(x => {
      if (this.registerForm.valid) {
        this.habilitarEnviar = 1;
      } else this.habilitarEnviar = 0;
    })
  }

  async enviar() {
    await this.functions.httpsCallable("preregistroInstructor")(this.registerForm.value).toPromise();
    this.enviado = true;
  }

}
